

// import { useState, useEffect } from "react"
// import { Container, Button, Card } from "react-bootstrap"
// import { FaUser, FaCalendar, FaUsers, FaBook, FaGraduationCap } from "react-icons/fa"
// import { useNavigate, useParams } from "react-router-dom"
// import axios from "axios"
// import Swal from "sweetalert2"
// import { Trash, XCircle, AlertCircle, Loader2 } from "lucide-react"
// import PropTypes from "prop-types"

// // Skeleton Loader Component
// const CourseSkeletonLoader = () => {
//   return (
//     <div className="course-page bg-light rounded">
//       <div className="position-relative">
//         {/* Banner Skeleton */}
//         <div className="banner-container rounded skeleton-bg">
//           <div className="banner-overlay">
//             <Container className="h-100 d-flex flex-column justify-content-between">
//               <div className="text-left">
//                 <div className="skeleton-text-lg mb-3"></div>
//                 <div className="skeleton-text-sm"></div>
//               </div>
//               <div className="d-flex align-items-center gap-3 mt-auto">
//                 <div className="skeleton-circle"></div>
//                 <div>
//                   <div className="skeleton-text-md"></div>
//                   <div className="skeleton-text-sm"></div>
//                 </div>
//               </div>
//             </Container>
//           </div>
//         </div>
//         {/* Card Skeleton */}
//         <Card className="course-info-card shadow-lg p-3">
//           <Card.Body>
//             <div className="skeleton-video mb-3"></div>
//             <div className="d-flex align-items-center gap-2 mb-3">
//               <div className="skeleton-icon"></div>
//               <div className="skeleton-text-sm"></div>
//             </div>
//             <div className="skeleton-text-md mb-3"></div>
//             <div className="mb-3">
//               <div className="d-flex gap-1">
//                 <div className="skeleton-badge"></div>
//                 <div className="skeleton-badge"></div>
//               </div>
//             </div>
//             <div className="d-flex flex-column gap-2 mb-3">
//               {[1, 2, 3].map((i) => (
//                 <div key={i} className="d-flex align-items-center gap-2">
//                   <div className="skeleton-icon"></div>
//                   <div className="skeleton-text-sm"></div>
//                 </div>
//               ))}
//             </div>
//             <div className="skeleton-button"></div>
//           </Card.Body>
//         </Card>
//       </div>
//       <style jsx>{`
//         .skeleton-bg {
//           background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
//           background-size: 200% 100%;
//           animation: 1.5s shine linear infinite;
//         }
//         .skeleton-text-lg {
//           height: 32px;
//           width: 70%;
//           background: rgba(255, 255, 255, 0.3);
//           border-radius: 4px;
//         }
//         .skeleton-text-md {
//           height: 20px;
//           width: 60%;
//           background: #e0e0e0;
//           border-radius: 4px;
//         }
//         .skeleton-text-sm {
//           height: 16px;
//           width: 40%;
//           background: #e0e0e0;
//           border-radius: 4px;
//         }
//         .skeleton-circle {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.3);
//         }
//         .skeleton-icon {
//           width: 20px;
//           height: 20px;
//           border-radius: 4px;
//           background: #e0e0e0;
//         }
//         .skeleton-video {
//           height: 150px;
//           background: #e0e0e0;
//           border-radius: 4px;
//         }
//         .skeleton-badge {
//           height: 24px;
//           width: 80px;
//           background: #e0e0e0;
//           border-radius: 16px;
//           margin-right: 8px;
//         }
//         .skeleton-button {
//           height: 48px;
//           width: 100%;
//           background: #e0e0e0;
//           border-radius: 10px;
//         }
//         @keyframes shine {
//           to {
//             background-position-x: -200%;
//           }
//         }
//       `}</style>
//     </div>
//   )
// }

// export default function Banner({ isInstructor, onEnroll = () => {} }) {
//   const { id } = useParams()
//   const navigate = useNavigate()
//   const token = localStorage.getItem("jwttoken")
//   const url = "https://kaasbackend.vetrinahealthcare.com/"

//   // Component State
//   const [course, setCourse] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)

//   // Enrollment and Button State
//   const [isEnrolled, setIsEnrolled] = useState(false)
//   const [enrollmentStatus, setEnrollmentStatus] = useState(null) // New state for 'P', 'A', etc.
//   const [enrollmentStatusLoading, setEnrollmentStatusLoading] = useState(true)
//   const [isProcessing, setIsProcessing] = useState(false) // Generic loader for button actions

//   // Course Details State
//   const [courseKeyPoints, setCourseKeyPoints] = useState([])
//   const [videoUrl, setVideoUrl] = useState(null)
//   const [courseImage, setCourseImage] = useState("")

//   // Modal and Form State
//   const [showAddModal, setShowAddModal] = useState(false)
//   const [formLoading, setFormLoading] = useState(false)
//   const [profileDataLoading, setProfileDataLoading] = useState(false)

//   // API Dropdown Data State
//   const [apiDropdownData, setApiDropdownData] = useState({
//     education: [],
//     occupation: [],
//     designations: [],
//     divisions: [],
//     departments: [],
//     subdivisions: [],
//   })

//   const [formData, setFormData] = useState({
//     first_name: "",
//     middle_name: "",
//     last_name: "",
//     email: "",
//     confirm_email: "",
//     password: "",
//     confirm_password: "",
//     mobile_number: "",
//     role: "Student",
//     role_id: 2,
//     address_line1: "",
//     village: "",
//     tehsil: "",
//     district: "",
//     state_address: "",
//     country: "",
//     pin_code: "",
//     occupation: "Farmer",
//     education: "Secondary",
//     degree: "",
//     farm_type: "",
//     farmer_agriculture_type: "",
//     farmer_livestock_type: "",
//     farmer_poultry_type: "",
//     farmer_aquaculture_type: "",
//     doctor_specialization: "",
//     business_nature: "",
//     business_company_name: "",
//     business_company_address: "",
//     service_company_name: "",
//     service_designation: "",
//     consultant_area: "",
//     employee_id: "",
//     employee_department: "",
//     employee_designation: "",
//     employee_division: "",
//     employee_headquarter: "",
//     employee_other_department: "",
//     employee_other_designation: "",
//     employee_other_division: "",
//   })
//   const [initialFormData, setInitialFormData] = useState({})

//   // Fetches both enrollment status and approval status
//   const checkEnrollmentStatus = async () => {
//     setEnrollmentStatusLoading(true)
//     try {
//       const response = await axios.get(`${url}lms/courses/${id}/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       setIsEnrolled(response.data.display.is_enrolled)
//       setEnrollmentStatus(response.data.status) // Capture the approval status
//     } catch (error) {
//       console.error("Error checking enrollment status:", error)
//     } finally {
//       setEnrollmentStatusLoading(false)
//     }
//   }

//   // Fetch course details on component mount
//   const fetchCourseData = async () => {
//     setLoading(true)
//     try {
//       const response = await axios.get(`${url}lms/courses/${id}/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       setCourse(response.data)
//       setCourseKeyPoints(response.data.course_key_points || [])
//       setIsEnrolled(response.data.display.is_enrolled)
//       setEnrollmentStatus(response.data.status) // Also set status here

//       const trailerUrl = response.data.trailer
//       if (trailerUrl) {
//         setVideoUrl(trailerUrl.startsWith("http") ? trailerUrl : `${url}${trailerUrl}`)
//       }

//       const imageUrl = response.data.cover_img
//       if (imageUrl) {
//         setCourseImage(imageUrl.startsWith("http") ? imageUrl : `${url}${imageUrl}`)
//       }
//     } catch (error) {
//       console.error("Error fetching course details:", error)
//       setError("Failed to load course details.")
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Failed to load course details!",
//         toast: true,
//         position: "top-end",
//         timer: 3000,
//         showConfirmButton: false,
//       })
//     } finally {
//       setLoading(false)
//       setEnrollmentStatusLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchCourseData()
//   }, [id, url, token])

//   const fetchDropdownData = async () => {
//     const endpoints = [
//       { name: "education", url: "https://kaasbackend.vetrinahealthcare.com/master/educations/" },
//       { name: "occupation", url: "https://kaasbackend.vetrinahealthcare.com/master/occupations/" },
//       { name: "designations", url: "https://kaasbackend.vetrinahealthcare.com/master/designations/" },
//       { name: "divisions", url: "https://kaasbackend.vetrinahealthcare.com/master/divisions/" },
//       { name: "departments", url: "https://kaasbackend.vetrinahealthcare.com/master/departments/" },
//       { name: "subdivisions", url: "https://kaasbackend.vetrinahealthcare.com/master/subdivisions/" },
//     ]

//     try {
//       const promises = endpoints.map((endpoint) =>
//         axios.get(endpoint.url, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//       )
//       const responses = await Promise.all(promises)
//       const dropdownData = responses.reduce((acc, response, index) => {
//         acc[endpoints[index].name] = response.data
//         return acc
//       }, {})
//       setApiDropdownData(dropdownData)
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error)
//     }
//   }

//   const deleteCourse = () => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         Swal.fire({
//           title: "Deleting...",
//           allowOutsideClick: false,
//           didOpen: () => Swal.showLoading(),
//         })

//         axios
//           .delete(`${url}lms/courses/${id}/`, {
//             headers: { Authorization: `Bearer ${token}` },
//           })
//           .then(() => {
//             Swal.fire("Deleted!", "The course has been deleted.", "success")
//             navigate("/createcourse")
//           })
//           .catch((error) => {
//             console.error("Error deleting course:", error)
//             Swal.fire("Error!", "Could not delete the course.", "error")
//           })
//       }
//     })
//   }

//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     let newFormData = { ...formData, [name]: value }

//     if (name === "occupation") {
//       const resetFields = {
//         farm_type: "",
//         farmer_agriculture_type: "",
//         farmer_livestock_type: "",
//         farmer_poultry_type: "",
//         farmer_aquaculture_type: "",
//         doctor_specialization: "",
//         business_nature: "",
//         business_company_name: "",
//         business_company_address: "",
//         service_company_name: "",
//         service_designation: "",
//         consultant_area: "",
//         employee_id: "",
//         employee_department: "",
//         employee_designation: "",
//         employee_division: "",
//         employee_headquarter: "",
//         employee_other_department: "",
//         employee_other_designation: "",
//         employee_other_division: "",
//       }
//       newFormData = { ...newFormData, ...resetFields }
//     }

//     if (name === "farm_type") {
//       newFormData = {
//         ...newFormData,
//         farmer_agriculture_type: "",
//         farmer_livestock_type: "",
//         farmer_poultry_type: "",
//         farmer_aquaculture_type: "",
//       }
//     }

//     setFormData(newFormData)
//   }

//   const preparePayload = (data) => {
//     const payload = { ...data }
//     delete payload.confirm_email
//     delete payload.confirm_password

//     if (payload.password === "") {
//       delete payload.password
//     }

//     // Handle 'Other' fields
//     if (payload.employee_department === "Other") payload.employee_department = payload.employee_other_department
//     if (payload.employee_designation === "Other") payload.employee_designation = payload.employee_other_designation
//     if (payload.employee_division === "Other") payload.employee_division = payload.employee_other_division

//     delete payload.employee_other_department
//     delete payload.employee_other_designation
//     delete payload.employee_other_division

//     return payload
//   }

//   const handlePayment = async (payload) => {
//     return new Promise((resolve, reject) => {
//       try {
//         const options = {
//           key: "rzp_test_XF9v6oecgVPv6f", // Replace with your actual Razorpay key
//           amount: course.price * 100,
//           currency: "INR",
//           name: "Kaas Subscription",
//           description: `Enrollment for ${course.title}`,
//           handler: (response) => {
//             console.log("Payment successful:", response)
//             resolve(response)
//           },
//           prefill: {
//             name: `${payload.first_name} ${payload.last_name}`,
//             email: payload.email,
//             contact: payload.mobile_number,
//           },
//           theme: { color: "#3399cc" },
//           modal: {
//             ondismiss: () => {
//               console.log("Payment modal dismissed")
//               reject(new Error("Payment was cancelled."))
//             },
//           },
//         }

//         const rzp = new window.Razorpay(options)
//         rzp.open()

//         rzp.on("payment.failed", (response) => {
//           console.error("Payment failed:", response.error)
//           reject(new Error("Payment failed: " + response.error.description))
//         })
//       } catch (error) {
//         reject(error)
//       }
//     })
//   }

//   const fetchProfileData = async () => {
//     setProfileDataLoading(true)
//     try {
//       const response = await axios.get(`${url}lms/student-self-profile/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       if (response.data) {
//         const profile = response.data
//         const profileData = {
//           first_name: profile.full_name?.split(" ")[0] || "",
//           middle_name: profile.full_name?.split(" ").slice(1, -1).join(" ") || "",
//           last_name: profile.full_name?.split(" ").slice(-1)[0] || "",
//           email: profile.email || "",
//           mobile_number: profile.mobile_number || "",
//           address_line1: profile.address_line1 || "",
//           village: profile.village || "",
//           tehsil: profile.tehsil || "",
//           district: profile.district || "",
//           state_address: profile.state || "",
//           country: profile.country || "",
//           pin_code: profile.pin_code || "",
//           occupation: profile.occupation || "",
//           education: profile.education || "",
//           degree: profile.degree || "",
//           farm_type: profile.farmer_farm_type || "",
//           farmer_agriculture_type: profile.farmer_agriculture_type || "",
//           farmer_livestock_type: profile.farmer_livestock_type || "",
//           farmer_poultry_type: profile.farmer_poultry_type || "",
//           farmer_aquaculture_type: profile.farmer_aquaculture_type || "",
//           doctor_specialization: profile.doctor_specialization || "",
//           business_nature: profile.business_nature || "",
//           business_company_name: profile.business_company_name || "",
//           business_company_address: profile.business_company_address || "",
//           service_company_name: profile.service_company_name || "",
//           service_designation: profile.service_designation || "",
//           consultant_area: profile.consultant_area || "",
//           employee_id: profile.employee_id || "",
//           employee_department: profile.employee_department || "",
//           employee_designation: profile.employee_designation || "",
//           employee_division: profile.employee_division || "",
//           employee_headquarter: profile.employee_headquarter || "",
//           password: "", // Always clear password fields
//           confirm_password: "",
//         }
//         setFormData(profileData)
//         setInitialFormData(profileData)
//       }
//     } catch (error) {
//       console.error("Error fetching profile data:", error)
//       Swal.fire({
//         icon: "error",
//         title: "Profile Error",
//         text: "Failed to load your profile data.",
//         toast: true,
//         position: "top-end",
//         timer: 3000,
//         showConfirmButton: false,
//       })
//     } finally {
//       setProfileDataLoading(false)
//     }
//   }

//   // Opens the modal
//   const handleEnrollClick = () => {
//     setIsProcessing(true) // Start the loader on the button
//     setShowAddModal(true)
//     fetchProfileData()
//     fetchDropdownData()
//   }

//   const handleProfileUpdate = async () => {
//     const payload = preparePayload(formData)
//     try {
//       await axios.put(`${url}lms/student-self-profile/`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       return true
//     } catch (error) {
//       console.error("Error updating profile:", error.response ? error.response.data : error)
//       Swal.fire({
//         icon: "error",
//         title: "Profile Update Failed",
//         text: "Could not update your profile. Please check your inputs.",
//       })
//       return false
//     }
//   }

//   // Handles submitting the initial enrollment request
//   const handleAddSubmit = async (e) => {
//     e.preventDefault()
//     if (formData.password && formData.password !== formData.confirm_password) {
//       Swal.fire("Error", "Passwords do not match!", "error")
//       return
//     }

//     setFormLoading(true)

//     const profileUpdated = await handleProfileUpdate()
//     if (!profileUpdated) {
//       setFormLoading(false)
//       setIsProcessing(false)
//       return
//     }

//     const payload = preparePayload(formData)

//     try {
//       await axios.post(`${url}lms/enroll/${id}/`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })

//       Swal.fire({
//         icon: "success",
//         title: "Request Sent!",
//         text: "Your enrollment request has been sent to the admin for approval.",
//         confirmButtonText: "OK",
//       })

//       setShowAddModal(false)
//       await fetchCourseData() // Re-fetch data to update the button status to "Pending"
//     } catch (error) {
//       console.error("Enrollment request failed:", error)
//       Swal.fire({
//         icon: "error",
//         title: "Request Failed",
//         text: error.message || "Could not send the enrollment request. Please try again.",
//       })
//     } finally {
//       setFormLoading(false)
//       setIsProcessing(false)
//     }
//   }

//   // Handles the payment and final enrollment after approval
//   const handlePaymentAndEnrollment = async () => {
//     setIsProcessing(true)
//     const payload = preparePayload(formData)
//     const isFree = !course.price || course.price === 0

//     try {
//       if (!isFree) {
//         // Paid course flow
//         await handlePayment(payload) // This will throw an error if payment fails/is cancelled
//       }

//       // If payment is successful or course is free, proceed with enrollment
//       await axios.post(`${url}lms/enroll/${id}/`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })

//       setIsEnrolled(true)
//       if (typeof onEnroll === "function") {
//         onEnroll(payload)
//       }

//       Swal.fire({
//         icon: "success",
//         title: "Enrollment Successful!",
//         html: `
//           <p>Welcome to <strong>${course.title}</strong></p>
//           <p>You can now access the course content.</p>
//         `,
//         confirmButtonText: "Continue",
//       })
//     } catch (error) {
//       console.error("Payment or final enrollment failed:", error)
//       Swal.fire({
//         icon: "error",
//         title: "Enrollment Failed",
//         text: error.message || "The process was not completed. Please try again.",
//       })
//     } finally {
//       setIsProcessing(false)
//     }
//   }

//   // Styles
//   const modalBackdropStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1300,
//   }

//   const modalContentStyle = {
//     backgroundColor: "white",
//     borderRadius: "10px",
//     padding: "0px",
//     width: "clamp(500px, 80vw, 900px)",
//     maxWidth: "95%",
//     maxHeight: "90vh",
//     display: "flex",
//     flexDirection: "column",
//   }

//   const modalHeaderStyle = {
//     padding: "15px 20px",
//     borderBottom: "1px solid #eee",
//     backgroundColor: "white",
//     position: "sticky",
//     top: 0,
//     zIndex: 10,
//   }

//   const modalBodyStyle = {
//     padding: "20px",
//     overflowY: "auto",
//     flexGrow: 1,
//   }

//   const modalFooterStyle = {
//     padding: "15px 20px",
//     borderTop: "1px solid #eee",
//     textAlign: "right",
//     backgroundColor: "white",
//     position: "sticky",
//     bottom: 0,
//     zIndex: 1,
//   }

//   const inputStyle = {
//     width: "100%",
//     padding: "10px",
//     border: "1px solid #ddd",
//     borderRadius: "5px",
//     boxSizing: "border-box",
//   }

//   const readOnlyInputStyle = {
//     ...inputStyle,
//     backgroundColor: "#f8f9fa",
//     border: "1px solid #ced4da",
//     cursor: "not-allowed",
//   }

//   const labelStyle = {
//     display: "block",
//     marginBottom: "5px",
//     fontWeight: "500",
//   }

//   const sectionStyle = {
//     borderBottom: "1px solid #eee",
//     paddingBottom: "8px",
//     marginBottom: "15px",
//     fontSize: "1.1rem",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   }

//   const gridContainerStyle = {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//     gap: "15px",
//     marginBottom: "20px",
//   }

//   if (loading) {
//     return <CourseSkeletonLoader />
//   }

//   if (!course) {
//     return (
//       <div className="alert alert-danger m-5 p-5 text-center">
//         <h3>Course not found</h3>
//         <p>The course you're looking for doesn't exist or has been removed.</p>
//         <Button variant="primary" onClick={() => navigate("/courses")} className="mt-3">
//           Browse Courses
//         </Button>
//       </div>
//     )
//   }

//   const MainContentLoader = () => (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "calc(100vh - 120px)", // Adjust for header height
//         backgroundColor: "#f8fafc",
//         padding: "20px",
//       }}
//     >
//       {/* Main loader animation */}
//       <div
//         style={{
//           position: "relative",
//           width: "80px",
//           height: "80px",
//           marginBottom: "30px",
//         }}
//       >
//         {/* Outer ring */}
//         <div
//           style={{
//             position: "absolute",
//             width: "80px",
//             height: "80px",
//             border: "4px solid #e2e8f0",
//             borderTop: "4px solid #3b82f6",
//             borderRadius: "50%",
//             animation: "spin 1s linear infinite",
//           }}
//         ></div>

//         {/* Inner ring */}
//         <div
//           style={{
//             position: "absolute",
//             top: "10px",
//             left: "10px",
//             width: "60px",
//             height: "60px",
//             border: "3px solid #e2e8f0",
//             borderTop: "3px solid #8b5cf6",
//             borderRadius: "50%",
//             animation: "spin 1.5s linear infinite reverse",
//           }}
//         ></div>

//         {/* Center dot */}
//         <div
//           style={{
//             position: "absolute",
//             top: "35px",
//             left: "35px",
//             width: "10px",
//             height: "10px",
//             backgroundColor: "#3b82f6",
//             borderRadius: "50%",
//             animation: "pulse 2s ease-in-out infinite",
//           }}
//         ></div>
//       </div>

//       {/* Loading text with gradient */}
//       <div
//         style={{
//           background: "linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899)",
//           backgroundSize: "200% 200%",
//           animation: "gradient 3s ease infinite",
//           WebkitBackgroundClip: "text",
//           WebkitTextFillColor: "transparent",
//           backgroundClip: "text",
//           fontSize: "24px",
//           fontWeight: "bold",
//           marginBottom: "10px",
//           textAlign: "center",
//         }}
//       >
//         Loading Student Profile
//       </div>

//       {/* Subtitle */}
//       <p
//         style={{
//           color: "#64748b",
//           fontSize: "16px",
//           textAlign: "center",
//           marginBottom: "30px",
//         }}
//       >
//         Fetching your profile data...
//       </p>

//       {/* Progress dots */}
//       <div style={{ display: "flex", gap: "8px" }}>
//         {[0, 1, 2].map((i) => (
//           <div
//             key={i}
//             style={{
//               width: "12px",
//               height: "12px",
//               backgroundColor: "#3b82f6",
//               borderRadius: "50%",
//               animation: `bounce 1.4s ease-in-out infinite both`,
//               animationDelay: `${i * 0.16}s`,
//             }}
//           ></div>
//         ))}
//       </div>

//       {/* Add CSS animations */}
//       <style>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
                  
//         @keyframes pulse {
//           0%, 100% { transform: scale(1); opacity: 1; }
//           50% { transform: scale(1.2); opacity: 0.7; }
//         }
                  
//         @keyframes gradient {
//           0% { background-position: 0% 50%; }
//           50% { background-position: 100% 50%; }
//           100% { background-position: 0% 50%; }
//         }
                  
//         @keyframes bounce {
//           0%, 80%, 100% {
//             transform: scale(0);
//           }
//           40% {
//             transform: scale(1);
//           }
//         }
//       `}</style>
//     </div>
//   )

//   // Error component for main content area
//   const MainContentError = () => (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "calc(100vh - 120px)",
//         backgroundColor: "#f8fafc",
//         padding: "20px",
//       }}
//     >
//       <div
//         style={{
//           textAlign: "center",
//           color: "#ef4444",
//           backgroundColor: "white",
//           padding: "40px",
//           borderRadius: "12px",
//           boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//           border: "1px solid #fecaca",
//           maxWidth: "500px",
//         }}
//       >
//         <XCircle style={{ width: "48px", height: "48px", margin: "0 auto 16px", color: "#ef4444" }} />
//         <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px" }}>Error Loading data</h3>
//         <p>{error}</p>
//         <button
//           onClick={() => window.location.reload()}
//           style={{
//             marginTop: "16px",
//             padding: "8px 16px",
//             backgroundColor: "#ef4444",
//             color: "white",
//             border: "none",
//             borderRadius: "6px",
//             cursor: "pointer",
//           }}
//         >
//           Retry
//         </button>
//       </div>
//     </div>
//   )

//   // No data component for main content area
//   const MainContentNoData = () => (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "calc(100vh - 120px)",
//         backgroundColor: "#f8fafc",
//         padding: "20px",
//       }}
//     >
//       <div
//         style={{
//           textAlign: "center",
//           color: "#0369a1",
//           backgroundColor: "white",
//           padding: "40px",
//           borderRadius: "12px",
//           boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//           border: "1px solid #bae6fd",
//           maxWidth: "500px",
//         }}
//       >
//         <AlertCircle style={{ width: "48px", height: "48px", margin: "0 auto 16px", color: "#0369a1" }} />
//         <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px" }}>No Data Found</h3>
//         <p>No student data found. Please check your connection and try again.</p>
//       </div>
//     </div>
//   )
//   const renderEnrollmentButton = () => {
//     // Instructor's view
//     if (isInstructor) {
//       return (
//         <>
//           <p className="text-info fw-bold">You're the instructor for this course.</p>
//           <Button
//             variant="warning"
//             className="w-100 rounded-pill fw-bold mt-2"
//             onClick={() => navigate(`/addcourseinfo/${id}`)}
//           >
//             Edit Course
//           </Button>
//           <Button variant="black" onClick={deleteCourse} className="position-absolute top-0 end-0 m-3">
//             <Trash size={20} />
//           </Button>
//         </>
//       )
//     }

//     // Initial check on page load
//     if (enrollmentStatusLoading) {
//       return (
//         <Button disabled className="w-100 btn-loading">
//           <Loader2 size={20} className="animate-spin" />
//           <span>Checking Status...</span>
//         </Button>
//       )
//     }

//     // Already fully enrolled
//     if (isEnrolled) {
//       return (
//         <div className="text-success fw-bold p-3 bg-light-success rounded text-center">
//           <div className="d-flex align-items-center justify-content-center gap-2">
//             <div className="text-success">✓</div>
//             <p className="mb-0">You are enrolled in this course</p>
//           </div>
//         </div>
//       )
//     }

//     // Request is pending admin approval
//     if (enrollmentStatus === "P") {
//       return (
//         <>
//           <Card.Text className="text-dark fw-bold mb-3 fs-5">
//             Price:{" "}
//             <span className="text-success">{!course.price || course.price === 0 ? "Free" : `₹ ${course.price}`}</span>
//           </Card.Text>
//           <Button disabled   className="w-100"
//   style={{ backgroundColor: "#ffc507ff", border: "none", color: "#000", fontWeight: "bold" }}>
            
//             <span>Enrollment Request Pending Approval</span>
//           </Button>
//         </>
//       )
//     }

//     // Request approved, waiting for payment
//     if (enrollmentStatus === "A" && !isEnrolled) {
//       return (
//         <>
//           <Card.Text className="text-dark fw-bold mb-3 fs-5">
//             Price:{" "}
//             <span className="text-success">{!course.price || course.price === 0 ? "Free" : `₹ ${course.price}`}</span>
//           </Card.Text>
//           <Button onClick={handlePaymentAndEnrollment} className="w-100 btn-enroll" disabled={isProcessing}>
//             {isProcessing ? (
//               <>
//                 <Loader2 size={20} className="animate-spin" />
//                 <span>Processing...</span>
//               </>
//             ) : (
//               "Pay Now to Enroll"
//             )}
//           </Button>
//         </>
//       )
//     }

//     // Default state: "Enroll Now"
//     return (
//       <>
//         <Card.Text className="text-dark fw-bold mb-3 fs-5">
//           Price:{" "}
//           <span className="text-success">{!course.price || course.price === 0 ? "Free" : `₹ ${course.price}`}</span>
//         </Card.Text>
//         <Button onClick={handleEnrollClick} className="w-100 btn-enroll" disabled={isProcessing}>
//           {isProcessing ? (
//             <>
//               <Loader2 size={20} className="animate-spin" />
//               <span>Processing...</span>
//             </>
//           ) : (
//             "Enroll Now"
//           )}
//         </Button>
//       </>
//     )
//   }

//   return (
//     <div className="course-page bg-light rounded">
//       {/* Course Banner */}
//       <div className="position-relative">
//         <div
//           className="banner-container rounded"
//           style={{
//             backgroundImage: courseImage ? `url("${courseImage}")` : "none",
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//             backgroundRepeat: "no-repeat",
//             minHeight: "300px",
//             width: "100%",
//           }}
//         >
//           <div className="banner-overlay">
//             <Container className="h-100 d-flex flex-column justify-content-between text-white">
//               <div className="text-left">
//                 <h1 className="fw-bold mb-3" style={{ fontSize: "clamp(1rem, 5vw, 3rem)" }}>
//                   {course.title}
//                 </h1>
//               </div>
//               <div className="d-flex align-items-center gap-3 mt-auto">
//                 <div className="bg-white rounded-circle p-2">
//                   <FaUser size={24} className="text-dark" />
//                 </div>
//                 <div>
//                   <div className="fw-bold">{course.instructor}</div>
//                   <div className="d-flex align-items-center gap-2">
//                     <FaCalendar size={14} />
//                     <small>{course.start_date}</small>
//                   </div>
//                 </div>
//               </div>
//             </Container>
//           </div>
//         </div>

//         {/* Course Info Card */}
//         <Card className="course-info-card shadow-lg p-3">
//           <Card.Body>
//             {/* Course Trailer */}
//             {videoUrl && (
//               <div className="mb-3">
//                 <h6 className="fw-bold">Course Trailer</h6>
//                 <div className="video-container">
//                   <video width="100%" controls>
//                     <source src={videoUrl} type="video/mp4" />
//                     Your browser does not support the video tag.
//                   </video>
//                 </div>
//               </div>
//             )}

//             {/* Enrolled Students */}
//             <div className="d-flex align-items-center gap-2 mb-3 text-muted">
//               <FaUsers className="text-warning" />
//               <span>{course.total_students || 0} Enrolled</span>
//             </div>

//             <h6 className="fw-bold mb-3">COURSE INFORMATION</h6>

//             {/* Categories */}
//             <div className="mb-3">
//               Categories:{" "}
//               {(course.categories || []).map((cat, index) => (
//                 <b key={index}>{cat}</b>
//               ))}
//             </div>

//             {/* Course Details */}
//             <div className="d-flex flex-column gap-2 mb-3 text-muted">
//               <div className="d-flex align-items-center gap-2">
//                 <FaBook className="text-secondary" />
//                 <small>{course.parts.length} Lessons</small>
//               </div>
//               <div className="d-flex align-items-center gap-2">
//                 <FaGraduationCap className="text-secondary" />
//                 <small>Certificate of Completion</small>
//               </div>
//             </div>

//             {/* Enrollment Button Logic */}
//             {renderEnrollmentButton()}
//           </Card.Body>
//         </Card>
//       </div>

//       {/* Course Key Points */}
//       {courseKeyPoints.length > 0 && (
//         <Container className="my-4">
//           <h4 className="fw-bold mb-3">What You'll Learn</h4>
//           <div className="row">
//             {courseKeyPoints.map((point, index) => (
//               <div key={index} className="col-md-6 mb-2">
//                 <div className="d-flex align-items-start">
//                   <div className="me-2 text-primary">✓</div>
//                   <div>{point}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </Container>
//       )}

//       {/* User Registration/Enrollment Modal */}
//       {showAddModal && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <div style={modalHeaderStyle}>
//               <h2
//                 style={{
//                   margin: 0,
//                   fontSize: "2rem",
//                   fontWeight: "bold",
//                   textAlign: "center",
//                   background: "linear-gradient(90deg, #f4811ee5, #B8529E, #f4811ee5)",
//                   backgroundSize: "200% auto",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                   animation: "gradientShift 3s linear infinite",
//                 }}
//               >
//                 Enroll in {course.title} Course
//               </h2>
//               {profileDataLoading && (
//                 <div style={{ textAlign: "center", marginTop: "10px", fontSize: "14px", color: "#666" }}>
//                   <span style={{ marginRight: "8px" }}>Loading profile data...</span>
//                   <div
//                     style={{
//                       display: "inline-block",
//                       width: "16px",
//                       height: "16px",
//                       border: "2px solid #f3f3f3",
//                       borderTop: "2px solid #3498db",
//                       borderRadius: "50%",
//                       animation: "spin 1s linear infinite",
//                     }}
//                   ></div>
//                 </div>
//               )}
//             </div>
//             {/* Added className="enrollment-form" to the form element */}
//             <form onSubmit={handleAddSubmit} style={modalBodyStyle} className="enrollment-form">
//               {profileDataLoading ? (
//                 <MainContentLoader />
//               ) : error ? (
//                 <MainContentError />
//               ) : !formData ? ( // Simplified check as formData is initialized
//                 <MainContentNoData />
//               ) : (
//                 <>
//                   {/* Personal Information */}
//                   <h3 style={sectionStyle}>Personal Information</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>First Name*</label>
//                       <input
//                         type="text"
//                         name="first_name"
//                         value={formData.first_name || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.first_name}
//                         style={initialFormData.first_name ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     {/* <div>
//                       <label style={labelStyle}>Middle Name</label>
//                       <input
//                         type="text"
//                         name="middle_name"
//                         value={formData.middle_name || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.middle_name}
//                         style={initialFormData.middle_name ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div> */}
//                     <div>
//                       <label style={labelStyle}>Last Name*</label>
//                       <input
//                         type="text"
//                         name="last_name"
//                         value={formData.last_name || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.last_name}
//                         style={initialFormData.last_name ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={{ whiteSpace: "nowrap", display: "block", marginBottom: "5px" }}>
//                         Mobile Number (WhatsApp)*
//                       </label>
//                       <input
//                         type="text"
//                         name="mobile_number"
//                         value={formData.mobile_number || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.mobile_number}
//                         style={initialFormData.mobile_number ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                   </div>

//                   {/* Login Credentials */}
//                   <h3 style={sectionStyle}>Login Credentials</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Email*</label>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email || ""}
//                         readOnly
//                         style={readOnlyInputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Password*</label>
//                       <input
//                         type="password"
//                         name="password"
//                         value={formData.password}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Confirm Password*</label>
//                       <input
//                         type="password"
//                         name="confirm_password"
//                         value={formData.confirm_password}
//                         onChange={handleInputChange}
//                         required
//                         style={inputStyle}
//                       />
//                     </div>
//                   </div>

//                   {/* Address Information */}
//                   <h3 style={sectionStyle}>Address Information</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Address Line 1*</label>
//                       <input
//                         type="text"
//                         name="address_line1"
//                         value={formData.address_line1 || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.address_line1}
//                         style={initialFormData.address_line1 ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Country*</label>
//                       <input
//                         type="text"
//                         name="country"
//                         value={formData.country || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.country}
//                         style={initialFormData.country ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>State*</label>
//                       <input
//                         type="text"
//                         name="state_address"
//                         value={formData.state_address || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.state_address}
//                         style={initialFormData.state_address ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>District*</label>
//                       <input
//                         type="text"
//                         name="district"
//                         value={formData.district || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.district}
//                         style={initialFormData.district ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Tehsil*</label>
//                       <input
//                         type="text"
//                         name="tehsil"
//                         value={formData.tehsil || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.tehsil}
//                         style={initialFormData.tehsil ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Village*</label>
//                       <input
//                         type="text"
//                         name="village"
//                         value={formData.village || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.village} // only read-only if it was prefilled initially
//                         style={initialFormData.village ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Pin Code*</label>
//                       <input
//                         type="text"
//                         name="pin_code"
//                         value={formData.pin_code || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.pin_code}
//                         style={initialFormData.pin_code ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                   </div>

//                   {/* Occupation and Education */}
//                   <h3 style={sectionStyle}>Occupation and Education</h3>
//                   <div style={gridContainerStyle}>
//                     <div>
//                       <label style={labelStyle}>Occupation*</label>
//                       {initialFormData.occupation ? (
//                         <input type="text" value={formData.occupation} readOnly style={readOnlyInputStyle} />
//                       ) : (
//                         <select
//                           name="occupation"
//                           value={formData.occupation}
//                           onChange={handleInputChange}
//                           style={inputStyle}
//                         >
//                           <option value="">Select Occupation</option>
//                           {apiDropdownData.occupation.map((occ) => (
//                             <option key={occ.id} value={occ.name}>
//                               {occ.name}
//                             </option>
//                           ))}
//                         </select>
//                       )}
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Education*</label>
//                       {initialFormData.education ? (
//                         <input type="text" value={formData.education} readOnly style={readOnlyInputStyle} />
//                       ) : (
//                         <select
//                           name="education"
//                           value={formData.education}
//                           onChange={handleInputChange}
//                           style={inputStyle}
//                         >
//                           <option value="">Select Education</option>
//                           {apiDropdownData.education.map((edu) => (
//                             <option key={edu.id} value={edu.name}>
//                               {edu.name}
//                             </option>
//                           ))}
//                         </select>
//                       )}
//                     </div>
//                     <div>
//                       <label style={labelStyle}>Degree</label>
//                       <input
//                         type="text"
//                         name="degree"
//                         value={formData.degree || ""}
//                         onChange={handleInputChange}
//                         readOnly={!!initialFormData.degree}
//                         style={initialFormData.degree ? readOnlyInputStyle : inputStyle}
//                       />
//                     </div>
//                   </div>

//                   {/* Occupation-specific fields */}
//                   {formData.occupation === "Farmer" && (
//                     <>
//                       <h3 style={sectionStyle}>Farmer Details</h3>
//                       <div style={gridContainerStyle}>
//                         <div>
//                           <label style={labelStyle}>Farm Type*</label>
//                           <input
//                             type="text"
//                             name="farm_type"
//                             value={formData.farm_type || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.farm_type}
//                             style={initialFormData.farm_type ? readOnlyInputStyle : inputStyle}
//                           />
//                         </div>
//                         {formData.farm_type === "Agriculture" && (
//                           <div>
//                             <label style={labelStyle}>Agriculture Type*</label>
//                             <input
//                               type="text"
//                               name="farmer_agriculture_type"
//                               value={formData.farmer_agriculture_type || ""}
//                               onChange={handleInputChange}
//                               readOnly={!!initialFormData.farmer_agriculture_type}
//                               style={
//                                 initialFormData.farmer_agriculture_type ? readOnlyInputStyle : inputStyle
//                               }
//                             />
//                           </div>
//                         )}
//                         {formData.farm_type === "Livestock" && (
//                           <div>
//                             <label style={labelStyle}>Livestock Type*</label>
//                             <input
//                               type="text"
//                               name="farmer_livestock_type"
//                               value={formData.farmer_livestock_type || ""}
//                               onChange={handleInputChange}
//                               readOnly={!!initialFormData.farmer_livestock_type}
//                               style={
//                                 initialFormData.farmer_livestock_type ? readOnlyInputStyle : inputStyle
//                               }
//                             />
//                           </div>
//                         )}
//                         {formData.farm_type === "Poultry" && (
//                           <div>
//                             <label style={labelStyle}>Poultry Type*</label>
//                             <input
//                               type="text"
//                               name="farmer_poultry_type"
//                               value={formData.farmer_poultry_type || ""}
//                               onChange={handleInputChange}
//                               readOnly={!!initialFormData.farmer_poultry_type}
//                               style={
//                                 initialFormData.farmer_poultry_type ? readOnlyInputStyle : inputStyle
//                               }
//                             />
//                           </div>
//                         )}
//                         {formData.farm_type === "Aquaculture" && (
//                           <div>
//                             <label style={labelStyle}>Aquaculture Type*</label>
//                             <input
//                               type="text"
//                               name="farmer_aquaculture_type"
//                               value={formData.farmer_aquaculture_type || ""}
//                               onChange={handleInputChange}
//                               readOnly={!!initialFormData.farmer_aquaculture_type}
//                               style={
//                                 initialFormData.farmer_aquaculture_type ? readOnlyInputStyle : inputStyle
//                               }
//                             />
//                           </div>
//                         )}
//                       </div>
//                     </>
//                   )}

//                   {formData.occupation === "Doctor" && (
//                     <>
//                       <h3 style={sectionStyle}>Doctor Details</h3>
//                       <div style={gridContainerStyle}>
//                         <div>
//                           <label style={labelStyle}>Specialization*</label>
//                           <input
//                             type="text"
//                             name="doctor_specialization"
//                             value={formData.doctor_specialization || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.doctor_specialization}
//                             style={initialFormData.doctor_specialization ? readOnlyInputStyle : inputStyle}
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}

//                   {formData.occupation === "Business" && (
//                     <>
//                       <h3 style={sectionStyle}>Business Details</h3>
//                       <div style={gridContainerStyle}>
//                         <div>
//                           <label style={labelStyle}>Nature of Business*</label>
//                           <input
//                             type="text"
//                             name="business_nature"
//                             value={formData.business_nature || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.business_nature}
//                             style={initialFormData.business_nature ? readOnlyInputStyle : inputStyle}
//                           />
//                         </div>
//                         <div>
//                           <label style={labelStyle}>Company Name*</label>
//                           <input
//                             type="text"
//                             name="business_company_name"
//                             value={formData.business_company_name || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.business_company_name}
//                             style={
//                               initialFormData.business_company_name ? readOnlyInputStyle : inputStyle
//                             }
//                           />
//                         </div>
//                         <div>
//                           <label style={labelStyle}>Company Address*</label>
//                           <input
//                             type="text"
//                             name="business_company_address"
//                             value={formData.business_company_address || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.business_company_address}
//                             style={
//                               initialFormData.business_company_address ? readOnlyInputStyle : inputStyle
//                             }
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}

//                   {formData.occupation === "Service" && (
//                     <>
//                       <h3 style={sectionStyle}>Service Details</h3>
//                       <div style={gridContainerStyle}>
//                         <div>
//                           <label style={labelStyle}>Company Name*</label>
//                           <input
//                             type="text"
//                             name="service_company_name"
//                             value={formData.service_company_name || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.service_company_name}
//                             style={
//                               initialFormData.service_company_name ? readOnlyInputStyle : inputStyle
//                             }
//                           />
//                         </div>
//                         <div>
//                           <label style={labelStyle}>Designation*</label>
//                           <input
//                             type="text"
//                             name="service_designation"
//                             value={formData.service_designation || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.service_designation}
//                             style={
//                               initialFormData.service_designation ? readOnlyInputStyle : inputStyle
//                             }
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}

//                   {formData.occupation === "Consultant" && (
//                     <>
//                       <h3 style={sectionStyle}>Consultant Details</h3>
//                       <div style={gridContainerStyle}>
//                         <div>
//                           <label style={labelStyle}>Consultant Area*</label>
//                           <input
//                             type="text"
//                             name="consultant_area"
//                             value={formData.consultant_area || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.consultant_area}
//                             style={initialFormData.consultant_area ? readOnlyInputStyle : inputStyle}
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}

//                   {formData.occupation === "Company employee" && (
//                     <>
//                       <h3 style={sectionStyle}>Employee Details</h3>
//                       <div style={gridContainerStyle}>
//                         <div>
//                           <label style={labelStyle}>Employee ID</label>
//                           <input
//                             type="text"
//                             name="employee_id"
//                             value={formData.employee_id || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.employee_id}
//                             style={initialFormData.employee_id ? readOnlyInputStyle : inputStyle}
//                           />
//                         </div>
//                         <div>
//                           <label style={labelStyle}>Department*</label>
//                           {initialFormData.employee_department ? (
//                             <input
//                               type="text"
//                               value={formData.employee_department}
//                               readOnly
//                               style={readOnlyInputStyle}
//                             />
//                           ) : (
//                             <select
//                               name="employee_department"
//                               value={formData.employee_department}
//                               onChange={handleInputChange}
//                               style={inputStyle}
//                             >
//                               <option value="">Select Department</option>
//                               {apiDropdownData.departments.map((dep) => (
//                                 <option key={dep.id} value={dep.name}>
//                                   {dep.name}
//                                 </option>
//                               ))}
//                             </select>
//                           )}
//                         </div>
//                         <div>
//                           <label style={labelStyle}>Designation*</label>
//                           {initialFormData.employee_designation ? (
//                             <input
//                               type="text"
//                               value={formData.employee_designation}
//                               readOnly
//                               style={readOnlyInputStyle}
//                             />
//                           ) : (
//                             <select
//                               name="employee_designation"
//                               value={formData.employee_designation}
//                               onChange={handleInputChange}
//                               style={inputStyle}
//                             >
//                               <option value="">Select Designation</option>
//                               {apiDropdownData.designations.map((des) => (
//                                 <option key={des.id} value={des.name}>
//                                   {des.name}
//                                 </option>
//                               ))}
//                             </select>
//                           )}
//                         </div>
//                         <div>
//                           <label style={labelStyle}>Division*</label>
//                           {initialFormData.employee_division ? (
//                             <input
//                               type="text"
//                               value={formData.employee_division}
//                               readOnly
//                               style={readOnlyInputStyle}
//                             />
//                           ) : (
//                             <select
//                               name="employee_division"
//                               value={formData.employee_division}
//                               onChange={handleInputChange}
//                               style={inputStyle}
//                             >
//                               <option value="">Select Division</option>
//                               {apiDropdownData.divisions.map((div) => (
//                                 <option key={div.id} value={div.name}>
//                                   {div.name}
//                                 </option>
//                               ))}
//                             </select>
//                           )}
//                         </div>
//                         <div>
//                           <label style={labelStyle}>Headquarter</label>
//                           <input
//                             type="text"
//                             name="employee_headquarter"
//                             value={formData.employee_headquarter || ""}
//                             onChange={handleInputChange}
//                             readOnly={!!initialFormData.employee_headquarter}
//                             style={
//                               initialFormData.employee_headquarter ? readOnlyInputStyle : inputStyle
//                             }
//                           />
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </>
//               )}
//             </form>
//             <div style={modalFooterStyle}>
//               <button
//                 onClick={() => {
//                   setShowAddModal(false)
//                   setIsProcessing(false) // Stop loader on cancel
//                 }}
//                 style={{
//                   padding: "8px 15px",
//                   background: "linear-gradient(90deg, #f4811ee5, #B8529E)",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                   marginRight: "10px",
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleAddSubmit}
//                 disabled={formLoading || profileDataLoading}
//                 style={{
//                   padding: "8px 15px",
//                   background: "linear-gradient(90deg, #f4811ee5, #B8529E)",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: formLoading || profileDataLoading ? "not-allowed" : "pointer",
//                   transition: "opacity 0.3s ease",
//                   opacity: formLoading || profileDataLoading ? 0.7 : 1,
//                 }}
//               >
//                 {formLoading
//                   ? "Processing..."
//                   : profileDataLoading
//                   ? "Loading..."
//                   : "Send Request to Admin"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Responsive Styling */}
//       <style jsx>{`
//         .banner-container {
//           height: 400px;
//           position: relative;
//           overflow: hidden;
//           background: linear-gradient(to right, #4a90e2, #1446a0);
//           display: flex;
//           align-items: center;
//           margin-top: 60px;
//           transition: all 0.3s ease;
//         }
//         .banner-overlay {
//           width: 100%;
//           height: 100%;
//           background: rgba(0, 0, 0, 0.5);
//           padding: 2rem;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: flex-start;
//           text-align: left;
//           transition: all 0.3s ease;
//         }
//         .course-info-card {
//           width: 320px;
//           position: absolute;
//           right: 0rem;
//           top: 0rem;
//           border: none;
//           padding: 0.8rem;
//           min-height: auto;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//           transition: all 0.3s ease;
//           transform: translateY(0);
//         }
//         .course-info-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
//         }
//         .course-info-card .card-body {
//           padding: 0.8rem;
//         }
//         .video-container {
//           border-radius: 8px;
//           overflow: hidden;
//           box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//         }
//         .bg-light-success {
//           background-color: rgba(25, 135, 84, 0.1);
//         }
//         .btn-enroll {
//           background: linear-gradient(135deg, #6a11cb, #2575fc);
//           border: none;
//           padding: 12px 20px;
//           font-size: 16px;
//           font-weight: bold;
//           border-radius: 10px;
//           box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
//           transition: all 0.3s ease-in-out;
//           position: relative;
//           overflow: hidden;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//         }
//         .btn-enroll:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 10px 15px rgba(0, 0, 0, 0.3);
//         }
//         .btn-loading {
//           background: linear-gradient(135deg, #6a11cb, #2575fc);
//           border: none;
//           padding: 12px 20px;
//           font-size: 16px;
//           font-weight: bold;
//           border-radius: 10px;
//           box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
//           opacity: 0.8;
//           cursor: not-allowed;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//         }
//         .animate-spin {
//           animation: spin 1s linear infinite;
//         }
//         .enrollment-form input,
//         .enrollment-form select {
//           transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
//         }
//         .enrollment-form input:not([readonly]):hover,
//         .enrollment-form select:hover {
//           border-color: #b8529e;
//           box-shadow: 0 0 0 3px rgba(184, 82, 158, 0.15);
//         }
//         @keyframes spin {
//           0% {
//             transform: rotate(0deg);
//           }
//           100% {
//             transform: rotate(360deg);
//           }
//         }
//         @keyframes gradientShift {
//           0% {
//             background-position: 0% center;
//           }
//           50% {
//             background-position: 100% center;
//           }
//           100% {
//             background-position: 0% center;
//           }
//         }
//         @media (max-width: 768px) {
//           .course-info-card {
//             width: 100%;
//             position: static;
//             margin-top: 1rem;
//           }
//           .banner-container {
//             height: 300px;
//           }
//           .banner-overlay {
//             padding: 1rem;
//           }
//           .banner-overlay h1 {
//             font-size: 2rem;
//           }
//         }
//       `}</style>
//     </div>
//   )
// }

// Banner.propTypes = {
//   isInstructor: PropTypes.bool,
//   onEnroll: PropTypes.func,
// }



import { useState, useEffect } from "react"
import { Container, Button, Card } from "react-bootstrap"
import { FaUser, FaCalendar, FaUsers, FaBook, FaGraduationCap } from "react-icons/fa"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import Swal from "sweetalert2"
import { Trash, XCircle, AlertCircle, Loader2 } from "lucide-react"
import PropTypes from "prop-types"

// Skeleton Loader Component
const CourseSkeletonLoader = () => {
  return (
    <div className="course-page bg-light rounded">
      <div className="position-relative">
        {/* Banner Skeleton */}
        <div className="banner-container rounded skeleton-bg">
          <div className="banner-overlay">
            <Container className="h-100 d-flex flex-column justify-content-between">
              <div className="text-left">
                <div className="skeleton-text-lg mb-3"></div>
                <div className="skeleton-text-sm"></div>
              </div>
              <div className="d-flex align-items-center gap-3 mt-auto">
                <div className="skeleton-circle"></div>
                <div>
                  <div className="skeleton-text-md"></div>
                  <div className="skeleton-text-sm"></div>
                </div>
              </div>
            </Container>
          </div>
        </div>
        {/* Card Skeleton */}
        <Card className="course-info-card shadow-lg p-3">
          <Card.Body>
            <div className="skeleton-video mb-3"></div>
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="skeleton-icon"></div>
              <div className="skeleton-text-sm"></div>
            </div>
            <div className="skeleton-text-md mb-3"></div>
            <div className="mb-3">
              <div className="d-flex gap-1">
                <div className="skeleton-badge"></div>
                <div className="skeleton-badge"></div>
              </div>
            </div>
            <div className="d-flex flex-column gap-2 mb-3">
              {[1, 2, 3].map((i) => (
                <div key={i} className="d-flex align-items-center gap-2">
                  <div className="skeleton-icon"></div>
                  <div className="skeleton-text-sm"></div>
                </div>
              ))}
            </div>
            <div className="skeleton-button"></div>
          </Card.Body>
        </Card>
      </div>
      <style jsx>{`
        .skeleton-bg {
          background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
          background-size: 200% 100%;
          animation: 1.5s shine linear infinite;
        }
        .skeleton-text-lg {
          height: 32px;
          width: 70%;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 4px;
        }
        .skeleton-text-md {
          height: 20px;
          width: 60%;
          background: #e0e0e0;
          border-radius: 4px;
        }
        .skeleton-text-sm {
          height: 16px;
          width: 40%;
          background: #e0e0e0;
          border-radius: 4px;
        }
        .skeleton-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.3);
        }
        .skeleton-icon {
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: #e0e0e0;
        }
        .skeleton-video {
          height: 150px;
          background: #e0e0e0;
          border-radius: 4px;
        }
        .skeleton-badge {
          height: 24px;
          width: 80px;
          background: #e0e0e0;
          border-radius: 16px;
          margin-right: 8px;
        }
        .skeleton-button {
          height: 48px;
          width: 100%;
          background: #e0e0e0;
          border-radius: 10px;
        }
        @keyframes shine {
          to {
            background-position-x: -200%;
          }
        }
      `}</style>
    </div>
  )
}

export default function Banner({ isInstructor, onEnroll = () => {} }) {
  const { id } = useParams()
  const navigate = useNavigate()
  const token = localStorage.getItem("jwttoken")
  const url = "https://kaasbackend.vetrinahealthcare.com/"

  // Component State
  const [course, setCourse] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Enrollment and Button State
  const [isEnrolled, setIsEnrolled] = useState(false)
  const [enrollmentStatus, setEnrollmentStatus] = useState(null)
  const [enrollmentStatusLoading, setEnrollmentStatusLoading] = useState(true)
  const [isProcessing, setIsProcessing] = useState(false)
  const [paymentProcessing, setPaymentProcessing] = useState(false) // Separate state for payment

  // Course Details State
  const [courseKeyPoints, setCourseKeyPoints] = useState([])
  const [videoUrl, setVideoUrl] = useState(null)
  const [courseImage, setCourseImage] = useState("")

  // Modal and Form State
  const [showAddModal, setShowAddModal] = useState(false)
  const [formLoading, setFormLoading] = useState(false)
  const [profileDataLoading, setProfileDataLoading] = useState(false)
  const [formErrors, setFormErrors] = useState({})

  // API Dropdown Data State
  const [apiDropdownData, setApiDropdownData] = useState({
    education: [],
    occupation: [],
    designations: [],
    divisions: [],
    departments: [],
    subdivisions: [],
  })

  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    confirm_email: "",
    password: "",
    confirm_password: "",
    mobile_number: "",
    role: "Student",
    role_id: 2,
    address_line1: "",
    village: "",
    tehsil: "",
    district: "",
    state_address: "",
    country: "",
    pin_code: "",
    occupation: "Farmer",
    education: "Secondary",
    degree: "",
    farm_type: "",
    farmer_agriculture_type: "",
    farmer_livestock_type: "",
    farmer_poultry_type: "",
    farmer_aquaculture_type: "",
    doctor_specialization: "",
    business_nature: "",
    business_company_name: "",
    business_company_address: "",
    service_company_name: "",
    service_designation: "",
    consultant_area: "",
    employee_id: "",
    employee_department: "",
    employee_designation: "",
    employee_division: "",
    employee_headquarter: "",
    employee_other_department: "",
    employee_other_designation: "",
    employee_other_division: "",
  })
  const [initialFormData, setInitialFormData] = useState({})

  // Validation function
  const validateForm = () => {
    const errors = {}
    const requiredFields = [
      'first_name', 'last_name', 'mobile_number', 'email', 'password', 
      'confirm_password', 'address_line1', 'country', 'state_address', 
      'district', 'tehsil', 'village', 'pin_code', 'occupation', 'education'
    ]

    // Check required fields
    requiredFields.forEach(field => {
      if (!formData[field] || formData[field].toString().trim() === '') {
        errors[field] = `${field.replace(/_/g, ' ')} is required`
      }
    })

    // Email validation
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid'
    }

    // Password validation
    if (formData.password && formData.password.length < 6) {
      errors.password = 'Password must be at least 6 characters'
    }

    if (formData.password !== formData.confirm_password) {
      errors.confirm_password = 'Passwords do not match'
    }

    // Mobile number validation
   if (
  formData.mobile_number &&
  !/^(\+\d{1,3})?\d{10}$/.test(formData.mobile_number)
) {
  errors.mobile_number = 'Enter a valid mobile number (10 digits, optional country code)';
}


    // Pin code validation
    if (formData.pin_code && !/^\d{6}$/.test(formData.pin_code)) {
      errors.pin_code = 'Pin code must be 6 digits'
    }

    // Occupation-specific validations
    if (formData.occupation === 'Farmer' && !formData.farm_type) {
      errors.farm_type = 'Farm type is required for farmers'
    }

    if (formData.occupation === 'Doctor' && !formData.doctor_specialization) {
      errors.doctor_specialization = 'Specialization is required for doctors'
    }

    if (formData.occupation === 'Business') {
      if (!formData.business_nature) errors.business_nature = 'Business nature is required'
      if (!formData.business_company_name) errors.business_company_name = 'Company name is required'
      if (!formData.business_company_address) errors.business_company_address = 'Company address is required'
    }

    if (formData.occupation === 'Service') {
      if (!formData.service_company_name) errors.service_company_name = 'Company name is required'
      if (!formData.service_designation) errors.service_designation = 'Designation is required'
    }

    if (formData.occupation === 'Consultant' && !formData.consultant_area) {
      errors.consultant_area = 'Consultant area is required'
    }

    if (formData.occupation === 'Company employee') {
      if (!formData.employee_department) errors.employee_department = 'Department is required'
      if (!formData.employee_designation) errors.employee_designation = 'Designation is required'
      if (!formData.employee_division) errors.employee_division = 'Division is required'
    }

    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  // Fetches both enrollment status and approval status
  const checkEnrollmentStatus = async () => {
    setEnrollmentStatusLoading(true)
    try {
      const response = await axios.get(`${url}lms/courses/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setIsEnrolled(response.data.display.is_enrolled)
      setEnrollmentStatus(response.data.status)
    } catch (error) {
      console.error("Error checking enrollment status:", error)
    } finally {
      setEnrollmentStatusLoading(false)
    }
  }

  // Fetch course details on component mount
  const fetchCourseData = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${url}lms/courses/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      setCourse(response.data)
      setCourseKeyPoints(response.data.course_key_points || [])
      setIsEnrolled(response.data.display.is_enrolled)
      setEnrollmentStatus(response.data.status)

      const trailerUrl = response.data.trailer
      if (trailerUrl) {
        setVideoUrl(trailerUrl.startsWith("http") ? trailerUrl : `${url}${trailerUrl}`)
      }

      const imageUrl = response.data.cover_img
      if (imageUrl) {
        setCourseImage(imageUrl.startsWith("http") ? imageUrl : `${url}${imageUrl}`)
      }
    } catch (error) {
      console.error("Error fetching course details:", error)
      setError("Failed to load course details.")
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to load course details!",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      })
    } finally {
      setLoading(false)
      setEnrollmentStatusLoading(false)
    }
  }

  useEffect(() => {
    fetchCourseData()
  }, [id, url, token])

  const fetchDropdownData = async () => {
    const endpoints = [
      { name: "education", url: "https://kaasbackend.vetrinahealthcare.com/master/educations/" },
      { name: "occupation", url: "https://kaasbackend.vetrinahealthcare.com/master/occupations/" },
      { name: "designations", url: "https://kaasbackend.vetrinahealthcare.com/master/designations/" },
      { name: "divisions", url: "https://kaasbackend.vetrinahealthcare.com/master/divisions/" },
      { name: "departments", url: "https://kaasbackend.vetrinahealthcare.com/master/departments/" },
      { name: "subdivisions", url: "https://kaasbackend.vetrinahealthcare.com/master/subdivisions/" },
    ]

    try {
      const promises = endpoints.map((endpoint) =>
        axios.get(endpoint.url, {
          headers: { Authorization: `Bearer ${token}` },
        })
      )
      const responses = await Promise.all(promises)
      const dropdownData = responses.reduce((acc, response, index) => {
        acc[endpoints[index].name] = response.data
        return acc
      }, {})
      setApiDropdownData(dropdownData)
    } catch (error) {
      console.error("Error fetching dropdown data:", error)
    }
  }

  const deleteCourse = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleting...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        })

        axios
          .delete(`${url}lms/courses/${id}/`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(() => {
            Swal.fire("Deleted!", "The course has been deleted.", "success")
            navigate("/createcourse")
          })
          .catch((error) => {
            console.error("Error deleting course:", error)
            Swal.fire("Error!", "Could not delete the course.", "error")
          })
      }
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    let newFormData = { ...formData, [name]: value }

    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }))
    }

    if (name === "occupation") {
      const resetFields = {
        farm_type: "",
        farmer_agriculture_type: "",
        farmer_livestock_type: "",
        farmer_poultry_type: "",
        farmer_aquaculture_type: "",
        doctor_specialization: "",
        business_nature: "",
        business_company_name: "",
        business_company_address: "",
        service_company_name: "",
        service_designation: "",
        consultant_area: "",
        employee_id: "",
        employee_department: "",
        employee_designation: "",
        employee_division: "",
        employee_headquarter: "",
        employee_other_department: "",
        employee_other_designation: "",
        employee_other_division: "",
      }
      newFormData = { ...newFormData, ...resetFields }
    }

    if (name === "farm_type") {
      newFormData = {
        ...newFormData,
        farmer_agriculture_type: "",
        farmer_livestock_type: "",
        farmer_poultry_type: "",
        farmer_aquaculture_type: "",
      }
    }

    setFormData(newFormData)
  }

  const preparePayload = (data) => {
    const payload = { ...data }
    delete payload.confirm_email
    delete payload.confirm_password

    if (payload.password === "") {
      delete payload.password
    }

    // Handle 'Other' fields
    if (payload.employee_department === "Other") payload.employee_department = payload.employee_other_department
    if (payload.employee_designation === "Other") payload.employee_designation = payload.employee_other_designation
    if (payload.employee_division === "Other") payload.employee_division = payload.employee_other_division

    delete payload.employee_other_department
    delete payload.employee_other_designation
    delete payload.employee_other_division

    return payload
  }

  const handlePayment = async (payload) => {
    return new Promise((resolve, reject) => {
      try {
        const options = {
          key: "rzp_test_XF9v6oecgVPv6f",
          amount: course.price * 100,
          currency: "INR",
          name: "Kaas Subscription",
          description: `Enrollment for ${course.title}`,
          handler: (response) => {
            console.log("Payment successful:", response)
            resolve(response)
          },
          prefill: {
            name: `${payload.first_name} ${payload.last_name}`,
            email: payload.email,
            contact: payload.mobile_number,
          },
          theme: { color: "#3399cc" },
          modal: {
            ondismiss: () => {
              console.log("Payment modal dismissed")
              reject(new Error("Payment was cancelled."))
            },
          },
        }

        const rzp = new window.Razorpay(options)
        rzp.open()

        rzp.on("payment.failed", (response) => {
          console.error("Payment failed:", response.error)
          reject(new Error("Payment failed: " + response.error.description))
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  const fetchProfileData = async () => {
    setProfileDataLoading(true)
    try {
      const response = await axios.get(`${url}lms/student-self-profile/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      if (response.data) {
        const profile = response.data
        const profileData = {
          first_name: profile.full_name?.split(" ")[0] || "",
          middle_name: profile.full_name?.split(" ").slice(1, -1).join(" ") || "",
          last_name: profile.full_name?.split(" ").slice(-1)[0] || "",
          email: profile.email || "",
          mobile_number: profile.mobile_number || "",
          address_line1: profile.address_line1 || "",
          village: profile.village || "",
          tehsil: profile.tehsil || "",
          district: profile.district || "",
          state_address: profile.state || "",
          country: profile.country || "",
          pin_code: profile.pin_code || "",
          occupation: profile.occupation || "",
          education: profile.education || "",
          degree: profile.degree || "",
          farm_type: profile.farmer_farm_type || "",
          farmer_agriculture_type: profile.farmer_agriculture_type || "",
          farmer_livestock_type: profile.farmer_livestock_type || "",
          farmer_poultry_type: profile.farmer_poultry_type || "",
          farmer_aquaculture_type: profile.farmer_aquaculture_type || "",
          doctor_specialization: profile.doctor_specialization || "",
          business_nature: profile.business_nature || "",
          business_company_name: profile.business_company_name || "",
          business_company_address: profile.business_company_address || "",
          service_company_name: profile.service_company_name || "",
          service_designation: profile.service_designation || "",
          consultant_area: profile.consultant_area || "",
          employee_id: profile.employee_id || "",
          employee_department: profile.employee_department || "",
          employee_designation: profile.employee_designation || "",
          employee_division: profile.employee_division || "",
          employee_headquarter: profile.employee_headquarter || "",
          password: "",
          confirm_password: "",
        }
        setFormData(profileData)
        setInitialFormData(profileData)
      }
    } catch (error) {
      console.error("Error fetching profile data:", error)
      Swal.fire({
        icon: "error",
        title: "Profile Error",
        text: "Failed to load your profile data.",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      })
    } finally {
      setProfileDataLoading(false)
    }
  }

  // Opens the modal
  const handleEnrollClick = () => {
    setIsProcessing(true)
    setShowAddModal(true)
    fetchProfileData()
    fetchDropdownData()
  }

  const handleProfileUpdate = async () => {
    const payload = preparePayload(formData)
    try {
      await axios.put(`${url}lms/student-self-profile/`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      return true
    } catch (error) {
      console.error("Error updating profile:", error.response ? error.response.data : error)
      Swal.fire({
        icon: "error",
        title: "Profile Update Failed",
        text: "Could not update your profile. Please check your inputs.",
      })
      return false
    }
  }

  // Handles submitting the initial enrollment request
  const handleAddSubmit = async (e) => {
    e.preventDefault()
    
    // Validate form before submission
    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fill all required fields correctly.",
        confirmButtonText: "OK",
      })
      return
    }

    if (formData.password && formData.password !== formData.confirm_password) {
      Swal.fire("Error", "Passwords do not match!", "error")
      return
    }

    setFormLoading(true)

    const profileUpdated = await handleProfileUpdate()
    if (!profileUpdated) {
      setFormLoading(false)
      setIsProcessing(false)
      return
    }

    const payload = preparePayload(formData)

    try {
      await axios.post(`${url}lms/enroll/${id}/`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })

      Swal.fire({
        icon: "success",
        title: "Request Sent!",
        text: "Your enrollment request has been sent to the admin for approval.",
        confirmButtonText: "OK",
      })

      setShowAddModal(false)
      await fetchCourseData()
    } catch (error) {
      console.error("Enrollment request failed:", error)
      const errorMessage = error.response?.data?.message || error.message || "Could not send the enrollment request. Please try again."
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: errorMessage,
      })
    } finally {
      setFormLoading(false)
      setIsProcessing(false)
    }
  }

  // Handles the payment and final enrollment after approval
  const handlePaymentAndEnrollment = async () => {
    setPaymentProcessing(true)
    
    try {
      const payload = preparePayload(formData)
      const isFree = !course.price || course.price === 0

      if (!isFree) {
        await handlePayment(payload)
      }

      await axios.post(`${url}lms/enroll/${id}/`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })

      setIsEnrolled(true)
      if (typeof onEnroll === "function") {
        onEnroll(payload)
      }

      Swal.fire({
        icon: "success",
        title: "Enrollment Successful!",
        html: `
          <p>Welcome to <strong>${course.title}</strong></p>
          <p>You can now access the course content.</p>
        `,
        confirmButtonText: "Continue",
      })
    } catch (error) {
      console.error("Payment or final enrollment failed:", error)
      const errorMessage = error.response?.data?.message || error.message || "The process was not completed. Please try again."
      Swal.fire({
        icon: "error",
        title: "Enrollment Failed",
        text: errorMessage,
      })
    } finally {
      setPaymentProcessing(false)
    }
  }

  // Styles
  const modalBackdropStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1300,
  }

  const modalContentStyle = {
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "0px",
    width: "clamp(500px, 80vw, 900px)",
    maxWidth: "95%",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
  }

  const modalHeaderStyle = {
    padding: "15px 20px",
    borderBottom: "1px solid #eee",
    backgroundColor: "white",
    position: "sticky",
    top: 0,
    zIndex: 10,
  }

  const modalBodyStyle = {
    padding: "20px",
    overflowY: "auto",
    flexGrow: 1,
  }

  const modalFooterStyle = {
    padding: "15px 20px",
    borderTop: "1px solid #eee",
    textAlign: "right",
    backgroundColor: "white",
    position: "sticky",
    bottom: 0,
    zIndex: 1,
  }

  const inputStyle = {
    width: "100%",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    boxSizing: "border-box",
  }

  const errorInputStyle = {
    ...inputStyle,
    border: "1px solid #dc3545",
    backgroundColor: "#fff5f5",
  }

  const readOnlyInputStyle = {
    ...inputStyle,
    backgroundColor: "#f8f9fa",
    border: "1px solid #ced4da",
    cursor: "not-allowed",
  }

  const labelStyle = {
    display: "block",
    marginBottom: "5px",
    fontWeight: "500",
  }

  const errorTextStyle = {
    color: "#dc3545",
    fontSize: "12px",
    marginTop: "4px",
    display: "block",
  }

  const sectionStyle = {
    borderBottom: "1px solid #eee",
    paddingBottom: "8px",
    marginBottom: "15px",
    fontSize: "1.1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }

  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
    marginBottom: "20px",
  }

  if (loading) {
    return <CourseSkeletonLoader />
  }

  if (!course) {
    return (
      <div className="alert alert-danger m-5 p-5 text-center">
        <h3>Course not found</h3>
        <p>The course you're looking for doesn't exist or has been removed.</p>
        <Button variant="primary" onClick={() => navigate("/courses")} className="mt-3">
          Browse Courses
        </Button>
      </div>
    )
  }

  const MainContentLoader = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 120px)",
        backgroundColor: "#f8fafc",
        padding: "20px",
      }}
    >
      {/* Main loader animation */}
      <div
        style={{
          position: "relative",
          width: "80px",
          height: "80px",
          marginBottom: "30px",
        }}
      >
        {/* Outer ring */}
        <div
          style={{
            position: "absolute",
            width: "80px",
            height: "80px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #3b82f6",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>

        {/* Inner ring */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            width: "60px",
            height: "60px",
            border: "3px solid #e2e8f0",
            borderTop: "3px solid #8b5cf6",
            borderRadius: "50%",
            animation: "spin 1.5s linear infinite reverse",
          }}
        ></div>

        {/* Center dot */}
        <div
          style={{
            position: "absolute",
            top: "35px",
            left: "35px",
            width: "10px",
            height: "10px",
            backgroundColor: "#3b82f6",
            borderRadius: "50%",
            animation: "pulse 2s ease-in-out infinite",
          }}
        ></div>
      </div>

      {/* Loading text with gradient */}
      <div
        style={{
          background: "linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899)",
          backgroundSize: "200% 200%",
          animation: "gradient 3s ease infinite",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "10px",
          textAlign: "center",
        }}
      >
        Loading Student Profile
      </div>

      {/* Subtitle */}
      <p
        style={{
          color: "#64748b",
          fontSize: "16px",
          textAlign: "center",
          marginBottom: "30px",
        }}
      >
        Fetching your profile data...
      </p>

      {/* Progress dots */}
      <div style={{ display: "flex", gap: "8px" }}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            style={{
              width: "12px",
              height: "12px",
              backgroundColor: "#3b82f6",
              borderRadius: "50%",
              animation: `bounce 1.4s ease-in-out infinite both`,
              animationDelay: `${i * 0.16}s`,
            }}
          ></div>
        ))}
      </div>

      {/* Add CSS animations */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
                  
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.2); opacity: 0.7; }
        }
                  
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
                  
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  )

  // Error component for main content area
  const MainContentError = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 120px)",
        backgroundColor: "#f8fafc",
        padding: "20px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          color: "#ef4444",
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          border: "1px solid #fecaca",
          maxWidth: "500px",
        }}
      >
        <XCircle style={{ width: "48px", height: "48px", margin: "0 auto 16px", color: "#ef4444" }} />
        <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px" }}>Error Loading data</h3>
        <p>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: "16px",
            padding: "8px 16px",
            backgroundColor: "#ef4444",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Retry
        </button>
      </div>
    </div>
  )

  // No data component for main content area
  const MainContentNoData = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 120px)",
        backgroundColor: "#f8fafc",
        padding: "20px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          color: "#0369a1",
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          border: "1px solid #bae6fd",
          maxWidth: "500px",
        }}
      >
        <AlertCircle style={{ width: "48px", height: "48px", margin: "0 auto 16px", color: "#0369a1" }} />
        <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px" }}>No Data Found</h3>
        <p>No student data found. Please check your connection and try again.</p>
      </div>
    </div>
  )

  const renderEnrollmentButton = () => {
    if (isInstructor) {
      return (
        <>
          <p className="text-info fw-bold">You're the instructor for this course.</p>
          <Button
            variant="warning"
            className="w-100 rounded-pill fw-bold mt-2"
            onClick={() => navigate(`/addcourseinfo/${id}`)}
          >
            Edit Course
          </Button>
          <Button variant="black" onClick={deleteCourse} className="position-absolute top-0 end-0 m-3">
            <Trash size={20} />
          </Button>
        </>
      )
    }

    if (enrollmentStatusLoading) {
      return (
        <Button disabled className="w-100 btn-loading">
          <Loader2 size={20} className="animate-spin" />
          <span>Checking Status...</span>
        </Button>
      )
    }

    if (isEnrolled) {
      return (
        <div className="text-success fw-bold p-3 bg-light-success rounded text-center">
          <div className="d-flex align-items-center justify-content-center gap-2">
            <div className="text-success">✓</div>
            <p className="mb-0">You are enrolled in this course</p>
          </div>
        </div>
      )
    }

    if (enrollmentStatus === "P") {
      return (
        <>
          <Card.Text className="text-dark fw-bold mb-3 fs-5">
            Price:{" "}
            <span className="text-success">{!course.price || course.price === 0 ? "Free" : `₹ ${course.price}`}</span>
          </Card.Text>
          <Button disabled className="w-100" style={{ backgroundColor: "#ffc507ff", border: "none", color: "#000", fontWeight: "bold" }}>
            <span>Enrollment Request Pending Approval</span>
          </Button>
        </>
      )
    }

    if (enrollmentStatus === "A" && !isEnrolled) {
      return (
        <>
          <Card.Text className="text-dark fw-bold mb-3 fs-5">
            Price:{" "}
            <span className="text-success">{!course.price || course.price === 0 ? "Free" : `₹ ${course.price}`}</span>
          </Card.Text>
          <Button 
            onClick={handlePaymentAndEnrollment} 
            className="w-100 btn-enroll" 
            disabled={paymentProcessing}
          >
            {paymentProcessing ? (
              <>
                <Loader2 size={20} className="animate-spin" />
                <span>Processing...</span>
              </>
            ) : (
              "Pay Now to Enroll"
            )}
          </Button>
        </>
      )
    }

    return (
      <>
        <Card.Text className="text-dark fw-bold mb-3 fs-5">
          Price:{" "}
          <span className="text-success">{!course.price || course.price === 0 ? "Free" : `₹ ${course.price}`}</span>
        </Card.Text>
        <Button onClick={handleEnrollClick} className="w-100 btn-enroll" disabled={isProcessing}>
          {isProcessing ? (
            <>
              <Loader2 size={20} className="animate-spin" />
              <span>Processing...</span>
            </>
          ) : (
            "Enroll Now"
          )}
        </Button>
      </>
    )
  }

  // Helper function to render form field with validation
  const renderFormField = (name, label, type = "text", options = null, required = true) => {
    const isError = formErrors[name]
    const inputStyleToUse = initialFormData[name] ? readOnlyInputStyle : (isError ? errorInputStyle : inputStyle)
    
    return (
      <div>
        <label style={labelStyle}>
          {label}{required && '*'}
        </label>
        {options ? (
          <select
            name={name}
            value={formData[name] || ''}
            onChange={handleInputChange}
            style={inputStyleToUse}
            disabled={!!initialFormData[name]}
          >
            <option value="">Select {label}</option>
            {options.map((option) => (
              <option key={option.id} value={option.name}>
                {option.name}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={type}
            name={name}
            value={formData[name] || ''}
            onChange={handleInputChange}
            readOnly={!!initialFormData[name]}
            style={inputStyleToUse}
            placeholder={`Enter ${label.toLowerCase()}`}
          />
        )}
        {isError && <span style={errorTextStyle}>{formErrors[name]}</span>}
      </div>
    )
  }

  return (
    <div className="course-page bg-light rounded">
      {/* Course Banner */}
      <div className="position-relative">
        <div
          className="banner-container rounded"
          style={{
            backgroundImage: courseImage ? `url("${courseImage}")` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            minHeight: "300px",
            width: "100%",
          }}
        >
          <div className="banner-overlay">
            <Container className="h-100 d-flex flex-column justify-content-between text-white">
              <div className="text-left">
                <h1 className="fw-bold mb-3" style={{ fontSize: "clamp(1rem, 5vw, 3rem)" }}>
                  {course.title}
                </h1>
              </div>
              <div className="d-flex align-items-center gap-3 mt-auto">
                <div className="bg-white rounded-circle p-2">
                  <FaUser size={24} className="text-dark" />
                </div>
                <div>
                  <div className="fw-bold">{course.instructor}</div>
                  <div className="d-flex align-items-center gap-2">
                    <FaCalendar size={14} />
                    <small>{course.start_date}</small>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </div>

        {/* Course Info Card */}
        <Card className="course-info-card shadow-lg p-3">
          <Card.Body>
            {/* Course Trailer */}
            {videoUrl && (
              <div className="mb-3">
                <h6 className="fw-bold">Course Trailer</h6>
                <div className="video-container">
                  <video width="100%" controls>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            )}

            {/* Enrolled Students */}
            <div className="d-flex align-items-center gap-2 mb-3 text-muted">
              <FaUsers className="text-warning" />
              <span>{course.total_students || 0} Enrolled</span>
            </div>

            <h6 className="fw-bold mb-3">COURSE INFORMATION</h6>

            {/* Categories */}
            <div className="mb-3">
              Categories:{" "}
              {(course.categories || []).map((cat, index) => (
                <b key={index}>{cat}</b>
              ))}
            </div>

            {/* Course Details */}
            <div className="d-flex flex-column gap-2 mb-3 text-muted">
              <div className="d-flex align-items-center gap-2">
                <FaBook className="text-secondary" />
                <small>{course.parts.length} Lessons</small>
              </div>
              <div className="d-flex align-items-center gap-2">
                <FaGraduationCap className="text-secondary" />
                <small>Certificate of Completion</small>
              </div>
            </div>

            {/* Enrollment Button Logic */}
            {renderEnrollmentButton()}
          </Card.Body>
        </Card>
      </div>

      {/* Course Key Points */}
      {courseKeyPoints.length > 0 && (
        <Container className="my-4">
          <h4 className="fw-bold mb-3">What You'll Learn</h4>
          <div className="row">
            {courseKeyPoints.map((point, index) => (
              <div key={index} className="col-md-6 mb-2">
                <div className="d-flex align-items-start">
                  <div className="me-2 text-primary">✓</div>
                  <div>{point}</div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      )}

      {/* User Registration/Enrollment Modal */}
      {showAddModal && (
        <div style={modalBackdropStyle}>
          <div style={modalContentStyle}>
            <div style={modalHeaderStyle}>
              <h2
                style={{
                  margin: 0,
                  fontSize: "2rem",
                  fontWeight: "bold",
                  textAlign: "center",
                  background: "linear-gradient(90deg, #f4811ee5, #B8529E, #f4811ee5)",
                  backgroundSize: "200% auto",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  animation: "gradientShift 3s linear infinite",
                }}
              >
                Enroll in {course.title} Course
              </h2>
              {profileDataLoading && (
                <div style={{ textAlign: "center", marginTop: "10px", fontSize: "14px", color: "#666" }}>
                  <span style={{ marginRight: "8px" }}>Loading profile data...</span>
                  <div
                    style={{
                      display: "inline-block",
                      width: "16px",
                      height: "16px",
                      border: "2px solid #f3f3f3",
                      borderTop: "2px solid #3498db",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  ></div>
                </div>
              )}
            </div>
            <form onSubmit={handleAddSubmit} style={modalBodyStyle} className="enrollment-form">
              {profileDataLoading ? (
                <MainContentLoader />
              ) : error ? (
                <MainContentError />
              ) : !formData ? (
                <MainContentNoData />
              ) : (
                <>
                  {/* Personal Information */}
                  <h3 style={sectionStyle}>Personal Information</h3>
                  <div style={gridContainerStyle}>
                    {renderFormField('first_name', 'First Name')}
                    {renderFormField('last_name', 'Last Name')}
                    {renderFormField('mobile_number', 'Mobile Number')}
                  </div>

                  {/* Login Credentials */}
                  <h3 style={sectionStyle}>Login Credentials</h3>
                  <div style={gridContainerStyle}>
                    <div>
                      <label style={labelStyle}>Email*</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email || ""}
                        readOnly
                        style={readOnlyInputStyle}
                      />
                      {formErrors.email && <span style={errorTextStyle}>{formErrors.email}</span>}
                    </div>
                    {renderFormField('password', 'Password', 'password')}
                    {renderFormField('confirm_password', 'Confirm Password', 'password')}
                  </div>

                  {/* Address Information */}
                  <h3 style={sectionStyle}>Address Information</h3>
                  <div style={gridContainerStyle}>
                    {renderFormField('address_line1', 'Address Line 1')}
                    {renderFormField('country', 'Country')}
                    {renderFormField('state_address', 'State')}
                    {renderFormField('district', 'District')}
                    {renderFormField('tehsil', 'Tehsil')}
                    {renderFormField('village', 'Village')}
                    {renderFormField('pin_code', 'Pin Code')}
                  </div>

                  {/* Occupation and Education */}
                  <h3 style={sectionStyle}>Occupation and Education</h3>
                  <div style={gridContainerStyle}>
                    {initialFormData.occupation ? (
                      <div>
                        <label style={labelStyle}>Occupation*</label>
                        <input type="text" value={formData.occupation} readOnly style={readOnlyInputStyle} />
                      </div>
                    ) : (
                      renderFormField('occupation', 'Occupation', 'select', apiDropdownData.occupation)
                    )}
                    {initialFormData.education ? (
                      <div>
                        <label style={labelStyle}>Education*</label>
                        <input type="text" value={formData.education} readOnly style={readOnlyInputStyle} />
                      </div>
                    ) : (
                      renderFormField('education', 'Education', 'select', apiDropdownData.education)
                    )}
                    {renderFormField('degree', 'Degree', 'text', null, false)}
                  </div>

                  {/* Occupation-specific fields */}
                  {formData.occupation === "Farmer" && (
                    <>
                      <h3 style={sectionStyle}>Farmer Details</h3>
                      <div style={gridContainerStyle}>
                        {renderFormField('farm_type', 'Farm Type')}
                        {formData.farm_type === "Agriculture" && renderFormField('farmer_agriculture_type', 'Agriculture Type')}
                        {formData.farm_type === "Livestock" && renderFormField('farmer_livestock_type', 'Livestock Type')}
                        {formData.farm_type === "Poultry" && renderFormField('farmer_poultry_type', 'Poultry Type')}
                        {formData.farm_type === "Aquaculture" && renderFormField('farmer_aquaculture_type', 'Aquaculture Type')}
                      </div>
                    </>
                  )}

                  {formData.occupation === "Doctor" && (
                    <>
                      <h3 style={sectionStyle}>Doctor Details</h3>
                      <div style={gridContainerStyle}>
                        {renderFormField('doctor_specialization', 'Specialization')}
                      </div>
                    </>
                  )}

                  {formData.occupation === "Business" && (
                    <>
                      <h3 style={sectionStyle}>Business Details</h3>
                      <div style={gridContainerStyle}>
                        {renderFormField('business_nature', 'Nature of Business')}
                        {renderFormField('business_company_name', 'Company Name')}
                        {renderFormField('business_company_address', 'Company Address')}
                      </div>
                    </>
                  )}

                  {formData.occupation === "Service" && (
                    <>
                      <h3 style={sectionStyle}>Service Details</h3>
                      <div style={gridContainerStyle}>
                        {renderFormField('service_company_name', 'Company Name')}
                        {renderFormField('service_designation', 'Designation')}
                      </div>
                    </>
                  )}

                  {formData.occupation === "Consultant" && (
                    <>
                      <h3 style={sectionStyle}>Consultant Details</h3>
                      <div style={gridContainerStyle}>
                        {renderFormField('consultant_area', 'Consultant Area')}
                      </div>
                    </>
                  )}

                  {formData.occupation === "Company employee" && (
                    <>
                      <h3 style={sectionStyle}>Employee Details</h3>
                      <div style={gridContainerStyle}>
                        {renderFormField('employee_id', 'Employee ID', 'text', null, false)}
                        {initialFormData.employee_department ? (
                          <div>
                            <label style={labelStyle}>Department*</label>
                            <input type="text" value={formData.employee_department} readOnly style={readOnlyInputStyle} />
                          </div>
                        ) : (
                          renderFormField('employee_department', 'Department', 'select', apiDropdownData.departments)
                        )}
                        {initialFormData.employee_designation ? (
                          <div>
                            <label style={labelStyle}>Designation*</label>
                            <input type="text" value={formData.employee_designation} readOnly style={readOnlyInputStyle} />
                          </div>
                        ) : (
                          renderFormField('employee_designation', 'Designation', 'select', apiDropdownData.designations)
                        )}
                        {initialFormData.employee_division ? (
                          <div>
                            <label style={labelStyle}>Division*</label>
                            <input type="text" value={formData.employee_division} readOnly style={readOnlyInputStyle} />
                          </div>
                        ) : (
                          renderFormField('employee_division', 'Division', 'select', apiDropdownData.divisions)
                        )}
                        {renderFormField('employee_headquarter', 'Headquarter', 'text', null, false)}
                      </div>
                    </>
                  )}
                </>
              )}
            </form>
            <div style={modalFooterStyle}>
              <button
                onClick={() => {
                  setShowAddModal(false)
                  setIsProcessing(false)
                  setFormErrors({})
                }}
                style={{
                  padding: "8px 15px",
                  background: "linear-gradient(90deg, #f4811ee5, #B8529E)",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleAddSubmit}
                disabled={formLoading || profileDataLoading}
                style={{
                  padding: "8px 15px",
                  background: "linear-gradient(90deg, #f4811ee5, #B8529E)",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: formLoading || profileDataLoading ? "not-allowed" : "pointer",
                  transition: "opacity 0.3s ease",
                  opacity: formLoading || profileDataLoading ? 0.7 : 1,
                }}
              >
                {formLoading
                  ? "Processing..."
                  : profileDataLoading
                  ? "Loading..."
                  : "Send Request to Admin"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Responsive Styling */}
      <style jsx>{`
        .banner-container {
          height: 400px;
          position: relative;
          overflow: hidden;
          background: linear-gradient(to right, #4a90e2, #1446a0);
          display: flex;
          align-items: center;
          margin-top: 60px;
          transition: all 0.3s ease;
        }
        .banner-overlay {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          padding: 2rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          text-align: left;
          transition: all 0.3s ease;
        }
        .course-info-card {
          width: 320px;
          position: absolute;
          right: 0rem;
          top: 0rem;
          border: none;
          padding: 0.8rem;
          min-height: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          transition: all 0.3s ease;
          transform: translateY(0);
        }
        .course-info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
        }
        .course-info-card .card-body {
          padding: 0.8rem;
        }
        .video-container {
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        .bg-light-success {
          background-color: rgba(25, 135, 84, 0.1);
        }
        .btn-enroll {
          background: linear-gradient(135deg, #6a11cb, #2575fc);
          border: none;
          padding: 12px 20px;
          font-size: 16px;
          font-weight: bold;
          border-radius: 10px;
          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease-in-out;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        .btn-enroll:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 15px rgba(0, 0, 0, 0.3);
        }
        .btn-loading {
          background: linear-gradient(135deg, #6a11cb, #2575fc);
          border: none;
          padding: 12px 20px;
          font-size: 16px;
          font-weight: bold;
          border-radius: 10px;
          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
          opacity: 0.8;
          cursor: not-allowed;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
        .enrollment-form input,
        .enrollment-form select {
          transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }
        .enrollment-form input:not([readonly]):hover,
        .enrollment-form select:hover {
          border-color: #b8529e;
          box-shadow: 0 0 0 3px rgba(184, 82, 158, 0.15);
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes gradientShift {
          0% {
            background-position: 0% center;
          }
          50% {
            background-position: 100% center;
          }
          100% {
            background-position: 0% center;
          }
        }
        @media (max-width: 768px) {
          .course-info-card {
            width: 100%;
            position: static;
            margin-top: 1rem;
          }
          .banner-container {
            height: 300px;
          }
          .banner-overlay {
            padding: 1rem;
          }
          .banner-overlay h1 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  )
}

Banner.propTypes = {
  isInstructor: PropTypes.bool,
  onEnroll: PropTypes.func,
}